import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const OrderDetailRolesRBAC = {
  pageID: '4f5716bd27fb611153517e4648187ff0',
  elementID: {
    ViewOrderDetailPage: '082444ebdad09120bf2bb82cbbd174c6',
    ViewPII: '43ae76eceaf1cf37a94bfe25107a681d',
  },
} as const

export const useAllowedForRBACOrderDetailPage = createUseRBAC(OrderDetailRolesRBAC.elementID)
export const useRBACOrderDetailPage = useAllowedForRBACOrderDetailPage

export type UseRBACOrderDetailPageType = ReturnType<typeof useRBACOrderDetailPage>
